import React from "react";
import { Stack, TextField } from "@mui/material";
import { OperandBuilder } from "../OperandBuilder";
import type { RuleComponentProps } from "./types";

export const RuleStartsWith: React.FC<RuleComponentProps> = ({
    value,
    onChange,
    evaluationDomain,
    declaredDerivedAttributeNames = [],
}) => {
    const sw = value?.startsWith;
    const left = sw?.left ?? { value: "" };
    const prefix = sw?.prefix ?? "";

    const updateLeft = (op: import("../../../../../../types/resolver").OperandDto | null) => {
        onChange({ startsWith: { ...sw, left: op ?? { value: "" }, prefix } });
    };

    const updatePrefix = (str: string) => {
        onChange({ startsWith: { ...sw, left, prefix: str } });
    };

    return (
        <Stack spacing={1}>
            <OperandBuilder
                label="Left"
                side="left"
                value={left}
                onChange={updateLeft}
                evaluationDomain={evaluationDomain}
                declaredDerivedAttributeNames={declaredDerivedAttributeNames}
                leftOperandTypes="keyOnly"
            />
            <TextField
                size="small"
                label="Prefix"
                value={prefix}
                onChange={(e) => updatePrefix(e.target.value)}
            />
        </Stack>
    );
};
